//Pomocné funkce pro práci s preferences API

export function mergeFlatIntoNested(obj: Record<string, any>): Record<string, any> {
	const result = { ...obj };

	Object.keys(obj).forEach((key) => {
		if (key.includes(".")) {
			const value = obj[key];
			const parts = key.split(".");

			let nested = {};
			let current = nested;
			for (let i = 0; i < parts.length; i++) {
				if (i === parts.length - 1) {
					current[parts[i]] = value;
				} else {
					current[parts[i]] = {};
					current = current[parts[i]];
				}
			}
			deepMerge(result, nested);
			delete result[key];
		}
	});

	return result;
}
function deepMerge(target: any, source: any) {
	for (const key in source) {
		if (
			source[key] instanceof Object &&
			key in target &&
			target[key] instanceof Object
		) {
			deepMerge(target[key], source[key]);
		} else {
			target[key] = source[key];
		}
	}
}

export function flattenDashboard(preferences: Record<string, any>): Record<string, any> {
	const result: Record<string, any> = {};

	Object.entries(preferences).forEach(([key, value]) => {
		result[`edocat.dashboard.${key}`] = value;
	});

	return result;
}

export function flattenUserProfile(preferences: Record<string, any>): Record<string, any> {
	const result: Record<string, any> = {};

	Object.entries(preferences).forEach(([key, value]) => {
		result[`edocat.trashPagination.${key}`] = value;
	});

	return result;
}